var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match-empty"},[_c('img',{attrs:{"src":require("@/assets/img/icon/icon_empty.png"),"alt":"icon_empty"}}),_c('br'),_c('p',[_vm._v(_vm._s(_vm.title)+" 업데이트 전입니다.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }